const STORAGE_KEY = 'nextcompli.inlet.attribution';

export type InletAttribution = {
  partner_code?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
};

const readStored = (): InletAttribution => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as InletAttribution;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeStored = (value: InletAttribution) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Ignore quota / private-mode failures.
  }
};

export const queryFromLocation = (search: string, hash = ''): string => {
  const trimmedSearch = (search || '').trim();
  if (trimmedSearch && trimmedSearch !== '?') {
    return trimmedSearch.startsWith('?') ? trimmedSearch : `?${trimmedSearch}`;
  }
  const hashMark = (hash || '').indexOf('?');
  if (hashMark >= 0) {
    return hash.slice(hashMark);
  }
  return '';
};

export const captureAttributionFromSearch = (search: string): InletAttribution => {
  const params = new URLSearchParams(queryFromLocation(search));
  const next: InletAttribution = { ...readStored() };
  const partner = (params.get('partner') || params.get('ref') || '').trim();
  const utmSource = (params.get('utm_source') || '').trim();
  const utmMedium = (params.get('utm_medium') || '').trim();
  const utmCampaign = (params.get('utm_campaign') || '').trim();
  if (partner) next.partner_code = partner.slice(0, 80);
  if (utmSource) next.utm_source = utmSource.slice(0, 120);
  if (utmMedium) next.utm_medium = utmMedium.slice(0, 120);
  if (utmCampaign) next.utm_campaign = utmCampaign.slice(0, 160);
  writeStored(next);
  return next;
};

export const captureAttributionFromWindow = (): InletAttribution => {
  if (typeof window === 'undefined') return {};
  return captureAttributionFromSearch(queryFromLocation(window.location.search || '', window.location.hash || ''));
};

export const getAttribution = (): InletAttribution => readStored();
